import classNames from "classnames";
import React from "react";
import style from "./style.scss";
import { Progress } from "../../form/Progress";

export const CircleMeter = ({ label, value, rankLow, rankMid, rankHigh, stroke }) => {
    return (
        <div
            className={classNames(style.base, {
                [style.rankLow]: rankLow,
                [style.rankMid]: rankMid,
                [style.rankHigh]: rankHigh
            })}
        >
            <Progress
                circle
                percent={value}
                rankLow={rankLow}
                rankMid={rankMid}
                rankHigh={rankHigh}
                strokeWidth={stroke}
                trailWidth={stroke}
            />
            <div className={style.label}>{label}</div>
        </div>
    );
};
